import { render, staticRenderFns } from "./Review.vue?vue&type=template&id=2fba6595"
import script from "./Review.vue?vue&type=script&lang=js"
export * from "./Review.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fba6595')) {
      api.createRecord('2fba6595', component.options)
    } else {
      api.reload('2fba6595', component.options)
    }
    module.hot.accept("./Review.vue?vue&type=template&id=2fba6595", function () {
      api.rerender('2fba6595', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/player/components/Review.vue"
export default component.exports